const module = { name: 'home/desktop/spotlightContent', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { Fandango_debugLog as debugLog } from 'require-core';



const Selectors = {
    CONTAINER: '.js-spotlightContent'
}


const Styles = {
    HIDE: 'hide'
}
function onDone(res) {
    if (!res || !res.markup) {
        return;
    }
    const $container = $(Selectors.CONTAINER);
    $container.append(res.markup);
    $container.removeClass(Styles.HIDE);
}
function onFail(err) {
    debugLog.warn('homeSpotlightContent API Fail', err);
}
function init() {
    xhr.ajax({
        method: 'GET',
        url: links.napiHomeSpotlightContent(),
    })
        .done(onDone)
        .fail(onFail);
}
module.exports = {
    init
};
export default module.exports;